import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

import type { AlertVariant } from '@ctct/presentation-layer';

export type Alert = {
  message: string;
  header?: string;
  id: string;
  variant?: AlertVariant;
};

export interface IAlertSlice {
  alerts: Alert[];
}

export const createAlertSliceDefaultValues = (): IAlertSlice => ({
  alerts: [],
});

export const createAlertSlice: StateCreator<IAlertSlice> = () => createAlertSliceDefaultValues();

export type AlertPageStore = UseBoundStore<StoreApi<IAlertSlice>>;

export const createAlertHooks = (pageStore: AlertPageStore) => {
  return {
    useAlerts: () => pageStore((state) => state.alerts),
  };
};

export type AlertHooks = ReturnType<typeof createAlertHooks>;
